import { mountRaceList } from './utils/mount-race-list.js';
import { STATE_URL } from './constants.js';

mountRaceList('ca-propositions', STATE_URL, {
  filter: { offices: ['I'], electionType: ['proposition'], sort: 'seat' },
  component: 'proposition',
  captionField: 'title',
}).catch(console.error);
